import { Tabs, styled } from '@mui/material';

const BooksTabsComponent = styled(Tabs)({
	marginInline: '4px',
});

export default BooksTabsComponent;
